<template>
  <span>
    <button
      type="button"
      id="popoverNotification"
      class="btn bg-neutral-dark text-info font-size-lg m-0 p-0 d-inline-block shadow-none text-center d-44 rounded-circle position-relative"
    >
      <font-awesome-icon :icon="['far', 'bell']" />
    </button>
    <span class="badge rounded-circle badge-danger badge-count">{{ dataNotif.notif_unread_count || 0 }}</span>
    <b-popover id="notification" placement="bottomleft" ref="popoverNotification" target="popoverNotification" triggers="hover">
      <span class="font-weight-bold text-title mx-3">Notifikasi</span>

      <b-row class="mt-4 mx-3">
        <b-col cols="6" class="fs-13 p-0">
          <span>Belum dibaca</span>
        </b-col>
        <b-col cols="6" class="fs-13 p-0 text-right">
          <span v-if="dataNotif.notif_unread.length < 1" class="text-muted">Tandai semua dibaca</span>
          <span v-else class="text-info pointer" @click="read('all')">Tandai semua dibaca</span>
        </b-col>
      </b-row>
      <div class="notif-content">
        <ul class="list-group list-group-flush text-left bg-transparent mt-2">
          <template v-if="dataNotif.notif_unread.length < 1">
            <li class="text-center">
              <hr>
              <small class="text-muted">Tidak ada notifikasi</small>
            </li>
          </template>
          <template v-else>
            <li
              class="list-group-item pointer bg-neutral-info py-2 px-3"
              v-for="(unread, index) in dataNotif.notif_unread"
              :key="index"
              @click="read(unread)"
            >
              <div class="align-box-row">
                <div class="icon-notif icon-unread text-center rounded-circle">
                  <font-awesome-icon icon="info-circle" />
                </div>
                <div class="pl-2">
                  <b-media right-align vertical-align="center">
                    <template #aside>
                      <small class="pb-1 d-block fs-11 mr-1">{{ unread.notif_date }}</small>
                      <span class="badge badge-circle badge-primary badge-header-alt mt-1">Online</span>
                    </template>
                    <span class="pb-1 d-block text-subtitle">{{ unread.title || '-' }}</span>
                    <span class="pb-1 d-block text-subtitle">Hi, {{ unread.user_name || '-' }}</span>
                    <small class="pb-1 d-block fs-11" v-html="unread.description"></small>
                  </b-media>
                </div>
              </div>
            </li>
          </template>
        </ul>
        <b-row class="m-3">
          <b-col cols="12" class="fs-13 p-0">
            <span>Sudah dibaca</span>
          </b-col>
        </b-row>
        <ul class="list-group list-group-flush text-left bg-transparent">
          <template v-if="dataNotif.notif_read.length < 1">
            <li class="text-center">
              <hr>
              <small class="text-muted">Tidak ada notifikasi</small>
            </li>
          </template>
          <template v-else>
            <li
              class="list-group-item pointer py-2 px-3"
              v-for="(read, idx) in dataNotif.notif_read"
              :key="idx"
              @click="struck(read)"
            >
              <div class="align-box-row">
                <div class="icon-notif icon-read text-center rounded-circle">
                  <font-awesome-icon icon="check-circle" />
                </div>
                <div class="pl-2">
                  <b-media right-align vertical-align="center">
                    <template #aside>
                      <small class="pb-1 d-block fs-11">{{ read.notif_date }}</small>
                    </template>
                    <span class="pb-1 d-block text-subtitle">{{ read.title || '-' }}</span>
                    <span class="pb-1 d-block text-subtitle">Hi, {{ read.user_name || '-' }}</span>
                    <small class="pb-1 d-block fs-11" v-html="read.description"></small>
                  </b-media>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </b-popover>
  </span>
</template>

<script>
  import Pusher from 'pusher-js'
  import { mapGetters } from 'vuex';
  import startCase from 'lodash/startCase';
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import { faBell as farBell } from '@fortawesome/free-regular-svg-icons';
  import { faInfoCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
  
  library.add(farBell, faInfoCircle, faCheckCircle);

  export default {
    components: {
      'font-awesome-icon': FontAwesomeIcon,
    },
    data() {
      return {
        dataNotif: {
          notif_unread_count: 0,
          notif_unread: [],
          notif_read: [],
        },
      };
    },
    computed: {
      ...mapGetters(['getKlinikId', 'getUser']),
    },
    mounted() {
      this.subscribe();
      this.fetchNotif();
    },
    methods: {
      subscribe(type = 'bind') {
        if (!this.pusher_config || !this.getUser) return;
        const config = this.pusher_config;
        if (!config.app_key || !config.app_cluster) return;

        let pusher = new Pusher(config.app_key, {
          cluster: config.app_cluster
        });
        pusher.subscribe(`pembayaran-klinik-${this.getUser.id}-${this.getKlinikId}`);
        if (type == 'unbind') {
          pusher.unbind('App\\Events\\PembayaranEvent');
          return;
        }
        pusher.bind('App\\Events\\PembayaranEvent', (data) => {
          if (data.status == 'LUNAS' && data.jenis_pembayaran == 'QRIS') {
            this.subscribe('unbind');
            if (['klinik-pembayaran-tambah', 'klinik-penjualan-tambah', 'klinik-penjualan-tambah-save'].includes(this.$route.name)) {
              this.$router.push(data.url);
            }
            this.swalNotif(data);
            this.fetchNotif();
          }
        });
      },
      async fetchNotif() {
        try {
          const res = await this.$axios.get(`notification?klinik_id=${this.getKlinikId}`);
          const { status, data } = res.data;
          if (status) {
            this.dataNotif = data;
          }
        } catch (error) {}
      },
      async read(data) {
        try {
          const res = await this.$axios.post(`notification`, {
            id: data == 'all' ? 'all' : data.id,
            klinik_id: this.getKlinikId,
          });
          const { status, message } = res.data;
          if (status) {
            if (data != 'all') this.struck(data);
            this.fetchNotif();
          } else {
            this.$swal({
              text: message,
              type: 'warning',
              confirmButtonText: startCase('ok'),
            });
          }
        } catch (error) {}
      },
      struck(data) {
        const route = this.$router.resolve({
          path: data.url,
        });
        window.open(route.href, '_blank');
      },
      swalNotif(data) {
        this.$swal({
          toast: true,
          background: '#e0eeff',
          padding: '0 1rem 1.5rem 1rem',
          position: 'center-end',
          showConfirmButton: false,
          showCloseButton: true,
          timer: 60000,
          customClass: {
            container: 'toast-14',
            closeButton: 'toast-close',
          },
          onOpen: () => {
            // Add click handler to message
            const message = document.querySelector('.swal2-content .align-box-row');
            if (message) {
              message.style.cursor = 'pointer';
              message.addEventListener('click', () => this.$swal.close());
            }
          },
          html: `
            <a class="align-box-row pointer" href="${data.url}" target="_blank">
              <div class="notif-toast rounded-circle">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-info-circle fa-w-16">
                  <path
                    fill="currentColor"
                    d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56
                    254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                  >
                  </path>
                </svg>
              </div>
              <div class="pl-2">
                <span class="text-header">${data.title}</span>
              </div>
            </a>
          `,
        });
      },
    },
  }
</script>

<style lang="css" scoped>
  .fs-11 {
    font-size: 11px;
  }
  .fs-13 {
    font-size: 13px;
  }
  .popover {
    min-width: 400px !important;
  }
  .badge-count {
    position: relative;
    left: -15px;
    top: 10px;
    z-index: 1;
    font-size: 10px;
  }
  .icon-notif {
    padding: 0.5rem;
    width: 35px;
    height: 35px;
  }
  .icon-unread {
    background: #fff;
    color: #3c44b1 !important;
  }
  .icon-read {
    background: #e5f9ed;
    color: #1bc943 !important;
  }
  .badge-circle {
    box-shadow: none !important;
  }
  .notif-content {
    overflow-y: auto;
    max-height: 75vh;
  }
  @media screen and (max-width: 1400px) {
    .notif-content {
      overflow-y: auto;
      max-height: 65vh;
    }
  }
  @media screen and (max-width: 1280px) {
    .badge-count {
      position: relative;
      left: 20px;
      top: -20px;
      z-index: 1;
      font-size: 10px;
    }
  }
  @media screen and (max-width: 500px) {
    .popover {
      min-width: 350px !important;
    }
  }
</style>

<style>
  #notification .popover-body {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  @media print {
    .toast-14 {
      display: none !important;
    }
  }
</style>
